import React, { Component } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import FemaleProfile from '../assets/images/user_profile_female.jpg';
import MaleProfile from "./../assets/images/user_profile_male.jpg";

const propTypes = {
	data: PropTypes.object.isRequired,
}

const defaultProps = {
	data: {
		image: FemaleProfile,
		name: '[Error]',
		sex: 'F'
	}
}

class UserDropdown extends Component {
	render() {
		let {name, sex, image} = this.props.data;
		return <div className="navbar-menu navbar-end">
			<div className={`navbar-item has-dropdown ${(this.state.profileShow ? 'is-active' : null)}`}>
				<a className="navbar-link" onClick={this.showProfile}><span className="profile-pic">
					<img src={(image ? image : (sex === 'H' ? MaleProfile : FemaleProfile))} alt="Usuario" /></span>
					{name}
				</a>
				<div className="navbar-dropdown">
					<NavLink to="/perfil" activeClassName="active" className="navbar-item">Mi perfil</NavLink>
					<hr className="navbar-divider" />
					<NavLink to="/logout" activeClassName="active" className="navbar-item">Cerrar sesión</NavLink>
				</div>
			</div>
			<p className="navbar-item" />
		</div>
	}

	constructor() {
		super();
		this.state = {
			profileShow: false
		}
		this.showProfile = this.showProfile.bind(this)
	}

	showProfile() {
		this.setState({
			profileShow: !this.state.profileShow
		});
	}
}

UserDropdown.propTypes = propTypes;
UserDropdown.defaultProps = defaultProps;

export default UserDropdown;


// WEBPACK FOOTER //
// ./src/elements/user-opts-dropdown.jsx